import React from "react";
import bookYourServiceImg from "../../Assets/About/bookNowSideImg.svg";

const BookYourService = () => {
  return (
    <div className="relative  bg-gradient-to-b md:bg-gradient-to-r  md:h-[400px]  from-[#C2775B] to-[#FFC7B2]  p-8 md:p-16 grid  md:grid-cols-2"data-aos="flip-up">
      <div className=" grid grid-rows-1 md:grid-rows-2 gap-4 ">
        <div className="flex flex-col gap-4">
          <h5 className="lato-thin-italic  text-[#E8D2CA]">
            Book Your Service
          </h5>
          <h2 className="  text-3xl md:text-4xl lg:5xl leading-6  tracking-wider font-serif font-medium text-white md:linelarge linesmall">
            NEED TO GET RELAX OR WANT TO RECHARGE?
          </h2>
        </div>
        <div className="py-4 lg:mt-8">
        <button className="py-3 px-12 text-[#ff6a00] font-semibold bg-[#FFFFFF] rounded">
            Book Now
          </button>
        </div>
      </div>
      <div className="hidden md:h-[500px] md:w-[50%]   md:block md:absolute  top-[-13%]  md:right-[16px] bottom-[-20%]">
        <img
          className="w-full h-full object-fill"
          src={bookYourServiceImg}
          alt="bookYourServiceImg"
        />
      </div>
    </div>
  );
};

export default BookYourService;
